<script setup>
import SvgIcon from '@/components/SvgIcon.vue';

// Vue twin of <x-close-button> (resources/views/components/close-button.blade.php).
// Single root, so caller classes and listeners reach the button through Vue's normal
// attribute fallthrough - Blade's explicit `class` prop is not needed here.
//
// Styled by button.close in resources/css/frontend/includes/form.scss, shared with the
// Blade side. `plain` opts out of the site's base button skin (the chain in form.scss).
defineProps({
    ariaLabel: { type: String, default: 'Close' },
});
</script>

<template>
    <button type="button" class="close plain" :aria-label="ariaLabel">
        <SvgIcon name="cross" />
    </button>
</template>
